import React from 'react';

import { MenuItem, Select, FormControl, InputLabel, SelectChangeEvent, OutlinedInput } from '@mui/material';

interface Warehouse {
  _id: string;
  name: string;

  [key: string]: any;
}

interface WarehouseSelectProps {
  warehouses: Warehouse[];
  onSelect: (warehouse: Warehouse) => void;
  selectedWarehouseId?: string;
}

const WarehouseSelect: React.FC<WarehouseSelectProps> = ({ warehouses, onSelect, selectedWarehouseId = '' }) => {
  // const [selectedWarehouseId, setSelectedWarehouseId] = React.useState<string>('');

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value as string;
    const selectedWarehouse = warehouses.find(warehouse => warehouse._id === selectedId);
    if (selectedWarehouse) {
      onSelect(selectedWarehouse);
    }
  };

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="warehouse-select-label" shrink={true}>
        Warehouse List*
      </InputLabel>
      <Select
        labelId="warehouse-select-label"
        id="warehouse-select"
        value={selectedWarehouseId}
        onChange={handleSelectChange}
        input={<OutlinedInput notched label="Warehouse List*" />}
        displayEmpty
      >
        {warehouses.map(warehouse => (
          <MenuItem key={warehouse._id} value={warehouse._id}>
            {warehouse.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default WarehouseSelect;
